import { useEffect, useState } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import { useForm } from "react-hook-form";
import CustomButton from "../../components/CustomButton/CustomButton";
import Multiselect from 'multiselect-react-dropdown';
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";

interface AddCompanyRevenueProps {
    show: boolean;
    handleClose: () => void;
    data?: any;
    plans: any[];
}

type FormData = {
    revenueName: string;
    planIds: string[];
}

const AddCompanyRevenue = ({ show, handleClose, data, plans }: AddCompanyRevenueProps) => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm<FormData>();
    const [isLoading, setLoading] = useState(false);
    const [planOptions, setPlanOptions] = useState<any[]>([]);
    const [selectedPlans, setSelectedPlans] = useState<any[]>([]);

    useEffect(() => {
        const options = plans.map((plan) => ({
            id: plan._id,
            name: plan.planName
        }));
        setPlanOptions(options);
    }, [plans])

    useEffect(() => {
        if (data) {
            reset({
                revenueName: data.revenueName,
            });
            const options = plans.map((plan) => ({
                id: plan._id,
                name: plan.planName
            }));
            setSelectedPlans(data.planIds.map((data: any) => options.find(option => option.id === data._id)));
        }
    }, [data])

    const onSubmit = (request: FormData) => {
        setLoading(true);
        request.planIds = selectedPlans.map(plan => plan.id);
        const apiCall = data && data._id
            ? WebService.putAPI({
                action: `company-revenue/edit-company-revenue/${data._id}`,
                body: request,
            })
            : WebService.postAPI({
                action: `company-revenue/add-company-revenue`,
                body: request,
            });
        apiCall
            .then((res: any) => {
                setLoading(false);
                handleClose();
                reset();
                setSelectedPlans([]);
                toast.success(res.message || 'Company revenue added successfully');
            })
            .catch((err: any) => {
                setLoading(false);
                toast.error(err.message || 'Something went wrong');
            })
    }

    return (
        <>
            <Offcanvas show={show} onHide={() => {
                handleClose();
                setSelectedPlans([]);
                reset({
                    revenueName: '',
                });
            }}
                placement="end"
                className="offcanvas-custom">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{data ? 'Edit' : 'Add'} Company Revenue</Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-2" controlId="revenuePlanName">
                            <Form.Label className="label">Revenue Name</Form.Label>
                            <Form.Control type="text" placeholder="Enter revenue name"
                                {...register("revenueName", { required: 'Revenue Name is required' })} />
                            {errors.revenueName && <div className="error-message">{errors.revenueName.message}</div>}
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="plan">
                            <Form.Label className="label">Plan</Form.Label>
                            <Multiselect
                                options={planOptions} // Options to display in the dropdown
                                selectedValues={selectedPlans} // Preselected value to persist in dropdown
                                onSelect={setSelectedPlans} // Function will trigger on select event
                                onRemove={setSelectedPlans} // Function will trigger on remove event
                                displayValue="name" // Property name to display in the dropdown options
                            />
                        </Form.Group>
                    </Form>
                </Offcanvas.Body>
                <div className="d-flex justify-content-end p-3">
                    <CustomButton
                        isLoading={isLoading}
                        label="Save"
                        className="w-100"
                        onClick={handleSubmit(onSubmit)}
                    />
                </div>
            </Offcanvas>
        </>
    )
}

export default AddCompanyRevenue;